import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Paginator } from "../../common/models/paginator";
import { debounceTime, distinctUntilChanged, finalize, map } from 'rxjs/operators';
import { SimpleMatDataSource } from '../../common/providers/simple-mat-data-source';
import { UrlFormatter } from '../../common/http/url-formatter';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject, Subscription } from 'rxjs';
import { DiscussionService } from '../discussion/discussion.service';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ConfigProvider} from "../../config-provider.service";
import { ParticipantService } from '../participant/participant.service';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { User } from "../../common/models/user";
import { Organization } from "../../common/models/organization";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf } from "@angular/common";
import {
  MatCell,
  MatCellDef, MatColumnDef, MatFooterCell,
  MatFooterCellDef, MatFooterRow,
  MatFooterRowDef, MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow,
  MatHeaderRowDef, MatRow,
  MatRowDef, MatTable
} from "@angular/material/table";
import { MatButton } from "@angular/material/button";
import { MatFormField, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatIcon } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'app-chat-share-participant-dialog',
  templateUrl: './share-participant-dialog.component.html',
  styleUrls: ['./share-participant-dialog.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatPaginator,
    MatDialogContent,
    NgIf,
    MatDialogClose,
    MatCellDef,
    MatFooterRowDef,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderCellDef,
    MatFooterCellDef,
    MatDialogTitle,
    MatColumnDef,
    MatButton,
    MatTable,
    MatSuffix,
    MatInput,
    MatFormField,
    MatSortModule,
    MatDialogActions,
    MatFooterCell,
    MatHeaderRow,
    MatCell,
    MatRow,
    MatFooterRow,
    MatHeaderCell,
    MatIcon,
    FlexLayoutModule,
  ],
  providers: [ParticipantService, DiscussionService]
})
export class ShareParticipantDialogComponent implements OnInit, AfterViewInit, OnDestroy {

    public organization: Organization = {} as Organization;
    public isLoading = true;
    public isSubmitting = false;
    public user: User = {} as User;
    public paginator: Paginator = {} as Paginator;
    public selection = new SelectionModel<number>(false, []); // set multiple to "true" to create chat discussion group
    // public columns: string[] = ['user', 'action'];
    public columns: string[] = ['user'];
    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    @ViewChild(MatPaginator, {static: false}) public MatPaginator: MatPaginator | undefined;

    public userFilterKeyUp = new Subject<KeyboardEvent>();
    private subscriptions: Subscription[] = [];

    constructor(
        private discussionService: DiscussionService,
        private urlFormatter: UrlFormatter,
        private participantService: ParticipantService,
        private utils: UtilsProvider,
        public dialogRef: MatDialogRef<ShareParticipantDialogComponent>,
        public conf: ConfigProvider,
        @Inject(MAT_DIALOG_DATA) public dialogData: any
    ) {
        this.user = dialogData.user;
        this.organization = dialogData.organization;

        this.urlFormatter.query.clear();

        this.userFilter();
    }

    public ngOnInit(): void {
        this.populateUsers(this.urlFormatter);
    }

    public ngAfterViewInit(): void {
        this.dataSource.paginator = this.MatPaginator!;
    }

    public onPaginateChange(event:any ) {
        this.urlFormatter.query.set('page', event.pageIndex + 1);

        this.populateUsers(this.urlFormatter);
    }

    /**
     * For single user selection only
     *
     * @param data
     */
    public onUserSelected(data:any) {
        this.dialogRef.close([data.id]);
    }

    public onSelect() {
        this.dialogRef.close(this.selection.selected);
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * Search filter
     */
    private userFilter(): void {
        this.subscriptions.push(
            this.userFilterKeyUp.pipe(
                debounceTime(250),
                distinctUntilChanged(),
                map((e: KeyboardEvent) => (e.target as HTMLInputElement).value),
            ).subscribe((value) => {
                this.urlFormatter.query.set('page', 1);
                this.urlFormatter.query.set('q', value);

                this.populateUsers(this.urlFormatter);
            })
        );
    }

    private populateUsers(urlFormatter: UrlFormatter): void {
        this.subscriptions.push(
            this.participantService.findAllByUserOrganizationsPaginated(this.user, urlFormatter, this.organization)
                .pipe(
                    finalize(() => this.isLoading = false)
                )
                .subscribe((paginatedUsers: Paginator) => {
                    this.paginator = paginatedUsers;
                    this.dataSource.replaceAllWith(this.paginator.data);
                })
        );
    }
}
